/* Non-colour variant options render as a <select>, but Dawn's VariantRadios reads
   radio inputs. This syncs the select into the hidden radios and re-fires Dawn's
   own change handler, so none of Dawn's variant logic needs modifying. */
if (!customElements.get('aurum-option-select')) {
  customElements.define('aurum-option-select', class extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      this.fieldset = this.closest('fieldset');
      if (!this.select || !this.fieldset) return;
      this.select.addEventListener('change', () => this.sync());
      // keep the select honest when Dawn disables combinations after another option changes
      this.observer = new MutationObserver(() => this.reflect());
      this.fieldset.querySelectorAll('input[type="radio"]').forEach((r) =>
        this.observer.observe(r, { attributes: true, attributeFilter: ['class', 'checked'] })
      );
      this.reflect();
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
    sync() {
      const value = this.select.value;
      const radio = [...this.fieldset.querySelectorAll('input[type="radio"]')]
        .find((r) => r.value === value);
      if (!radio || radio.checked) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    reflect() {
      const checked = this.fieldset.querySelector('input[type="radio"]:checked');
      if (checked && this.select.value !== checked.value) this.select.value = checked.value;
      [...this.select.options].forEach((opt) => {
        const radio = [...this.fieldset.querySelectorAll('input[type="radio"]')]
          .find((r) => r.value === opt.value);
        opt.disabled = !!(radio && radio.classList.contains('disabled'));
      });
    }
  });
}

/* Dawn re-renders price and media on variant change, but not the option legend,
   so the colour name printed next to the swatches would go stale. Keep it in sync. */
document.addEventListener('change', (e) => {
  const input = e.target;
  if (!input || input.type !== 'radio') return;
  const fieldset = input.closest('.product-form__input--swatch');
  if (!fieldset) return;
  const out = fieldset.querySelector('.aurum-swatch-value');
  if (out) out.textContent = input.value;
});
